import { Dialog as MuiDialog, SxProps, Theme, DialogProps, Breakpoint } from "@mui/material"
import { ReactNode } from "react"

interface DialogPropsType extends DialogProps {
  open: boolean
  toggleDialog: () => void
  children: ReactNode
  maxWidth?: Breakpoint
  sx?: SxProps<Theme>
}

const Dialog = ({ open, toggleDialog, maxWidth, children, sx, ...rest }: DialogPropsType) => {
  return (
    <MuiDialog
      open={open}
      onClose={toggleDialog}
      maxWidth={maxWidth}
      sx={{ backdropFilter: "blur(1px)", ...sx }}
      {...rest}
    >
      {children}
    </MuiDialog>
  )
}

export default Dialog
